import { render, staticRenderFns } from "./SuggestAnalysis.vue?vue&type=template&id=4ceb4114&scoped=true"
import script from "./SuggestAnalysis.vue?vue&type=script&lang=js"
export * from "./SuggestAnalysis.vue?vue&type=script&lang=js"
import style0 from "./SuggestAnalysis.vue?vue&type=style&index=0&id=4ceb4114&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceb4114",
  null
  
)

export default component.exports